module.exports = __webpack_public_path__ + "./Camille_color_52642830d161964cc2f3d699ee900a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Camille_color.jpg
// module id = 614
// module chunks = 0